import { useGetMerchantAppProductsQuery } from "Api/Queries/Merchants/useGetMerchantAppProductsQuery";
import { useGetMerchantPricingsQuery } from "Api/Queries/Merchants/useGetMerchantPricingsQuery";
import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";
import { isComgateProductCode } from "Components/Shared/Merchant/Products/AppProducts/constants";

export const useIsPricingSetForAllMerchantProducts = (merchantID: string) => {
  const {
    data: merchantData,
    isLoading: isMerchantLoading,
    isError: isMerchantError,
  } = useGetMerchantQuery(merchantID);
  const {
    data: merchantProducts,
    isLoading: isMerchantProductsLoading,
    isError: isMerchantProductsError,
  } = useGetMerchantAppProductsQuery(merchantID);
  const {
    data: allAvailablePricings = [],
    isLoading: isPricingsLoading,
    isError: isPricingsError,
  } = useGetMerchantPricingsQuery();

  const relevantPricings = allAvailablePricings.filter((p) =>
    merchantProducts?.some((product) => product.productDto.code === p.code),
  );

  // Comgate devices carry their own price list, set with the contract level at activation; there is no
  // merchant fee to wait for.
  const pricingsList = relevantPricings
    .map((pricing) => pricing.code)
    .filter((code) => !isComgateProductCode(code))
    .filter((code, index, array) => array.indexOf(code) === index);

  const isError = isMerchantError || isMerchantProductsError || isPricingsError;
  const isLoading =
    isMerchantLoading || isMerchantProductsLoading || isPricingsLoading;

  const isPricingSetForAllMerchantProducts = !!(
    merchantData?.fees &&
    pricingsList.every((pricingCode) =>
      merchantData.fees.some((fee) => fee.productCode === pricingCode),
    )
  );

  return {
    isPricingSetForAllMerchantProducts,
    isLoading,
    isError,
  };
};
